import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { motion } from "framer-motion";

import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
} from "reactstrap";
import classnames from "classnames";
import { isEmpty, map } from "lodash";

//Import Star Ratings
import StarRatings from "react-star-ratings";

// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { FaMicrophone } from "react-icons/fa";
//Import Product Images
import { productImages } from "assets/images/product";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import data
import { discountData, productsData } from "common/data";

//Import actions
import { getProducts as onGetProducts } from "store/e-commerce/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";
import { getAllProperties, searchProperties } from "service/api";
import { Home, X } from "lucide-react";

const propertyTypes = [
    { value: "Apartment", label: "Apartment" },
    { value: "Villa", label: "Villa" },
    { value: "Independent House", label: "Independent House" },
    { value: "Studio Apartment", label: "Studio Apartment" },
    { value: "Penthouse", label: "Penthouse" },
    { value: "Townhouse", label: "Townhouse" },
    { value: "Cottage", label: "Cottage" },
    { value: "Bungalow", label: "Bungalow" },
    { value: "Farmhouse", label: "Farmhouse" },
    { value: "Condominium", label: "Condominium" },
    { value: "Loft", label: "Loft" },
    { value: "Serviced Apartment", label: "Serviced Apartment" },
    { value: "Office Space", label: "Office Space" },
    { value: "Retail Space", label: "Retail Space" },
    { value: "Warehouse", label: "Warehouse" },
    { value: "Industrial Property", label: "Industrial Property" },
    { value: "Shop", label: "Shop" },
    { value: "Showroom", label: "Showroom" },
    { value: "Hotel", label: "Hotel" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "Agricultural Land", label: "Agricultural Land" },
    { value: "Plot/Land", label: "Plot/Land" },
    { value: "Beach House", label: "Beach House" },
    { value: "Mountain Cabin", label: "Mountain Cabin" },
    { value: "Vacation Home", label: "Vacation Home" },
    { value: "Luxury Estate", label: "Luxury Estate" },
    { value: "Heritage Property", label: "Heritage Property" },
    { value: "Eco-Friendly Home", label: "Eco-Friendly Home" },
    { value: "Smart Home", label: "Smart Home" },
    { value: "Garage", label: "Garage" },
    { value: "Parking Space", label: "Parking Space" },
    { value: "Storage Unit", label: "Storage Unit" },
    { value: "Mixed-Use Property", label: "Mixed-Use Property" },
];
const availabilitys = [
    { value: "Immediate", label: "Immediate" },
    { value: "Within 15 days", label: "Within 15 days" },
    { value: "Within 30 days", label: "Within 30 days" },
    { value: "After 30 days", label: "Studio After 30 days" },
];


const EcommerceProducts = () => {

    //meta title
    document.title = "Properties | Aiinrealestate";

    const navigate = useNavigate();


    const [filters, setFilters] = useState({
        discount: [],
        price: { min: 0, max: 500 },
    });


    // useEffect(() => {
    //   setProductList(products);
    //   setDiscountDataList(discountData);
    // }, [products, discountData]);

    // useEffect(() => {
    //   dispatch(onGetProducts());
    // }, [dispatch]);

    // useEffect(() => {
    //   if (!isEmpty(products)) setProductList(products);
    // }, [products]);



    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    const cardStyle = {
        background: "rgba(255, 255, 255, 0.1)",
        border: "none",
        borderRadius: "15px",
    };


    // const [properties, setProperties] = useState([]);

    // const fetchProperty = async () => {
    //   try {
    //     const data = await getAllProperties();
    //     console.log("Fetched Data:", data); // Debugging

    //     if (data?.success && Array.isArray(data.properties)) {
    //       setProperties(data.properties); // ✅ Correct key
    //     } else {
    //       console.error("Error fetching properties:", data?.message || "Unknown error");
    //       setProperties([]); // Prevent crash if API fails
    //     }
    //   } catch (error) {
    //     console.error("API Error:", error);
    //     setProperties([]); // Prevent crash if API fails
    //   }
    // };

    // // Fetch on component mount
    // useEffect(() => {
    //   fetchProperty();
    // }, []);

    const [properties, setProperties] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isListening, setIsListening] = useState(false);
    const [selectedArea, setSelectedArea] = useState("");
    const [minPrice, setMinPrice] = useState("");
    const [maxPrice, setMaxPrice] = useState("");
    const [isDropdownOpenarea, setIsDropdownOpenarea] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedCommercialTypes, setSelectedCommercialTypes] = useState([]);
    const [selectedBHK, setSelectedBHK] = useState(null);

    const propertyOptions = ["Residential", "Commercial", "Other Property Types"];
    const [subPropertyType, setSubPropertyType] = useState(null);

    const residentialOptions = ["Flat", "House/Villa"];
    const bhkOptions = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5+ BHK"];

    const commercialOptions = [
        "Office Space",
        "Shop/Showroom",
        "Commercial Land",
        "Warehouse/Godown",
        "Industrial Building",
        "Industrial Shed",
    ];

    const otherOptions = ["Agricultural", "Farm House"];

    // const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    const handleSelectProperty = (type) => {
        setPropertyType(type);
        setSubPropertyType(null);
        setSelectedCommercialTypes([]);
        setSelectedBHK(null);
    };

    const handleSubPropertySelect = (subType) => {
        setSubPropertyType(subType);
        setSelectedBHK(null);
    };

    const handleBHKSelect = (bhk) => {
        setSelectedBHK(bhk);
    };

    const handleCommercialSelect = (type) => {
        setSelectedCommercialTypes((prev) =>
            prev.includes(type) ? prev.filter((item) => item !== type) : [...prev, type]
        );
    };

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const handleSelectArea = (area) => {
        if (selectedAreas.includes(area)) {
            setSelectedAreas(selectedAreas.filter((item) => item !== area));
        } else if (selectedAreas.length < 3) {
            setSelectedAreas([...selectedAreas, area]);
        }
        setIsDropdownOpenarea(false);
    };
    const fetchProperty = async () => {
        try {
            const data = await getAllProperties();
            console.log("Fetched Data:", data); // Debugging

            // Ensure properties is always an array
            if (data?.success && Array.isArray(data.properties)) {
                setProperties(data.properties);
            } else {
                console.error("Invalid response format:", data);
                setProperties([]); // Prevent crash
            }
        } catch (error) {
            console.error("API Error:", error);
            setProperties([]);
        }
    };

    // Fetch all properties on component mount
    useEffect(() => {
        fetchProperty();
    }, []);

    const handleSearch = async (input) => {
        // const query = e.target.value;
        const query = input?.target?.value ?? input;
        setSearchQuery(query);

        if (!query) {
            fetchProperty(); // If query is empty, reset to all properties
            return;
        }

        try {
            const data = await searchProperties(query);
            console.log("Search Response:", data); // Debugging

            // Ensure properties is always an array
            if (data?.success && Array.isArray(data.properties)) {
                setProperties(data.properties);
            } else {
                console.error("Invalid search response format:", data);
                setProperties([]);
            }
        } catch (error) {
            console.error("Search API Error:", error);
            setProperties([]);
        }
    };

    const toggleListening = () => {
        if (!isListening) {
            startListening();
        } else {
            stopListening();
        }
    };
    // 🟢 Voice Search Function
    const startListening = () => {
        if (!("webkitSpeechRecognition" in window)) {
            alert("Your browser does not support voice search.");
            return;
        }

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListening(true);
        recognition.onend = () => setIsListening(false);

        recognition.onresult = (event) => {
            const spokenText = event.results[0][0].transcript;
            setSearchQuery(spokenText);
            handleSearch({ target: { value: spokenText } });
        };

        recognition.start();
        console.log("Mic is ON");
    };

    const stopListening = () => {
        setIsListening(false);
        // Stop the speech recognition logic
        console.log("Mic is OFF");
    };
    const clearSearch = () => {
        setSearchQuery("");
    };
    // const [searchQuery, setSearchQuery] = useState("");
    const [propertyType, setPropertyType] = useState("");
    const [visibleCount, setVisibleCount] = useState(10);

    const [availability, setavailability] = useState("");
    const [transactionType, setTransactionType] = useState(null);
    const vadodaraAreas = [
        "Alkapuri", "Fatehgunj", "Gorwa", "Gotri", "Manjalpur", "Waghodia", "Bhayli", "Harni", "Tarsali", "Makarpura", "Ellora Park", "Karelibaug", "Subhanpura", "Chhani", "New VIP Road", "Sayajiganj", "Ajwa Road", "Akota", "Atladara", "Bajwa", "Baranpura", "Diwalipura", "GIDC Makarpura", "Kothi", "Nizampura", "Panchvati", "Pratapgunj", "Rajmahal Road", "Sama", "Sama-Savli Road", "Sun Pharma Road", "Vadsar", "Vasna Road", "Wadi", "Kalali", "Sevasi", "Sindhrot", "Tandalja", "Vishwamitri"
    ];
    const priceOptions = ["₹5 Lac", "₹10 Lac", "₹20 Lac", "₹30 Lac", "₹40 Lac", "₹50 Lac", "₹60 Lac", "₹70 Lac", "₹80 Lac", "₹90 Lac", "₹1 Cr", "₹1.2 Cr", "₹1.4 Cr", "₹1.6 Cr", "1.8 Cr", "₹2 Cr", "₹2.3 Cr", "₹2.6 Cr", "₹3 Cr", "₹3.5 Cr", "₹3.5 Cr", "₹4 Cr", "₹4.5 Cr", "₹5 Cr", "₹10 Cr", "₹20 Cr"];

    const filteredAreas = vadodaraAreas.filter((area) =>
        area.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // const handleCategoryClick = (category) => {
    //     setSearchQuery(category);
    //     handleSearch(category);
    // };

    const loadMoreAreas = () => {
        setVisibleCount((prevCount) => prevCount + 10);
    };

    const whatsappNumber = "919586363303";
    const whatsappMessage = encodeURIComponent(
        `Hello, I would like to post a property. I am sharing the required details:\n\n📍 Property Location: \n🏠 Property type
 \n Built-up Year: \n📏 Area (in sq. feet): \n🖼️ Images of property \n Video of property

: \n📄 Additional Information: \n`
    );

    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    const [selectedCategory, setSelectedCategory] = useState(null);

    // Handle category selection
    // Merged category click handler
    const handleCategoryClick = (category) => {
        setSearchQuery(category);
        handleSearch(category);

        // Show "1 Year", "2 Years", "3 Years" only if "Possession Within?" is selected
        if (category === "Possesion Within") {
            setSelectedCategory(category);
        } else {
            setSelectedCategory(null); // Hide sub-options when selecting another category
        }
    };
    const toggleDropdown = () => {
        setIsDropdownOpenarea((prev) => !prev);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <Breadcrumbs title="Ecommerce" breadcrumbItem="Products" /> */}
                    <Row>
                        <Col lg={12}>
                            {/* Category Buttons */}
                            {/* <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                                <h6 style={{ color: "#C0C0C0", fontWeight: "bold", margin: 0 }}>Possession With In?</h6>
                            </div> */}

                            {/* Category Buttons */}
                            {/* <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                                {["Upcomming Projects", "Ready To Move", "Possesion Within?", "1 Year", "2 Years", "3 Years"].map((category) => (
                                    <motion.button
                                        key={category}
                                        onClick={() => handleCategoryClick(category)}
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        style={{
                                            padding: "10px 10px",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            background: "linear-gradient(135deg, #5A189A, #9D4EDD)",
                                            color: "#fff",
                                            border: "1px solid #9D4EDD",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                            transition: "all 0.3s ease",
                                            boxShadow: "0 4px 12px rgba(157, 78, 221, 0.3)",
                                        }}
                                    >
                                        {category}
                                    </motion.button>
                                ))}
                            </div> */}

                            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                                {["Upcomming Projects", "Ready To Move", "Possesion Within"].map((category) => (
                                    <motion.button
                                        key={category}
                                        onClick={() => handleCategoryClick(category)}
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        style={{
                                            padding: "10px 10px",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            background: "linear-gradient(135deg, #5A189A, #9D4EDD)",
                                            color: "#fff",
                                            border: "1px solid #9D4EDD",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            transition: "all 0.3s ease",
                                            boxShadow: "0 4px 12px rgba(157, 78, 221, 0.3)",
                                        }}
                                    >
                                        {category}
                                    </motion.button>
                                ))}
                            </div>

                            {/* Sub-options for "Possession Within?" */}
                            {selectedCategory === "Possesion Within" && (
                                <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", marginTop: "15px" }}>
                                    {["1 Year", "2 Years", "3 Years"].map((category) => (
                                        <motion.button
                                            key={category}
                                            onClick={() => handleCategoryClick(category)}
                                            whileHover={{ scale: 1.1 }}
                                            whileTap={{ scale: 0.9 }}
                                            style={{
                                                padding: "10px 10px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                background: "linear-gradient(135deg, #FF5733, #C70039)",
                                                color: "#fff",
                                                border: "1px solid #C70039",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 4px 12px rgba(199, 0, 57, 0.3)",
                                            }}
                                        >
                                            {category}
                                        </motion.button>
                                    ))}
                                </div>
                            )}

                            {/* <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "16px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    background: "rgba(255, 255, 255, 0.1)", // Glass effect
                                    padding: "12px 20px",
                                    borderRadius: "12px",
                                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.2)",
                                    backdropFilter: "blur(8px)",
                                }}
                            >
                                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                    {["Buy", "Rent", "Plot", "Commercial"].map((category) => (
                                        <motion.button
                                            key={category}
                                            onClick={() => handleCategoryClick(category)}
                                            whileHover={{ scale: 1.1 }}
                                            whileTap={{ scale: 0.9 }}
                                            style={{
                                                padding: "10px 18px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                background: "linear-gradient(135deg, #5A189A, #9D4EDD)",
                                                color: "#fff",
                                                border: "1px solid #9D4EDD",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 4px 12px rgba(157, 78, 221, 0.3)",
                                            }}
                                        >
                                            {category}
                                        </motion.button>
                                    ))}

                                    <a href="" target="_blank" rel="noopener noreferrer">
                                        <motion.button
                                            whileHover={{ scale: 1.1 }}
                                            whileTap={{ scale: 0.9 }}
                                            style={{
                                                padding: "10px 18px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                background: "linear-gradient(135deg, #5A189A, #9D4EDD)",
                                                color: "#fff",
                                                border: "1px solid #9D4EDD",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 4px 12px rgba(157, 78, 221, 0.3)",
                                            }}
                                        >
                                            <Home size={20} color="#fff" />
                                            New Projects
                                        </motion.button>
                                    </a>
                                </div>

                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5 }}
                                    style={{ display: "flex", gap: "10px", alignItems: "center" }}
                                >
                                    <span style={{ fontWeight: "bold", fontSize: "16px", color: "#fff" }}>
                                        Post Property through WhatsApp
                                    </span>
                                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                                        <motion.button
                                            whileHover={{ scale: 1.1 }}
                                            whileTap={{ scale: 0.9 }}
                                            style={{
                                                padding: "10px 18px",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                background: "linear-gradient(135deg, #25D366, #128C7E)",
                                                color: "#fff",
                                                border: "1px solid #128C7E",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                transition: "all 0.3s ease",
                                                boxShadow: "0 4px 12px rgba(19, 169, 88, 0.3)",
                                            }}
                                        >
                                            <FaWhatsapp size={20} color="#fff" />
                                            WhatsApp
                                        </motion.button>
                                    </a>
                                </motion.div>
                            </div>
                            <br /> */}
                            <br />
                            <Row className="mb-1">
                                <Col lg={12} sm={6}>
                                    <Form
                                        className="d-flex flex-wrap align-items-center bg-white p-2 shadow-sm w-100"
                                        style={{
                                            maxWidth: "1400px",
                                            borderRadius: "10px",
                                            border: "1px solid #ddd",
                                        }}
                                    >

                                        <div className="d-flex align-items-center flex-grow-1 px-3" style={{ minWidth: "300px" }}>
                                            <Input
                                                type="text"
                                                className="form-control border-0"
                                                placeholder="Search localities or landmarks..."
                                                value={searchQuery}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    paddingLeft: "15px",
                                                    borderRadius: "50px",
                                                    height: "45px",
                                                    boxShadow: "none",
                                                    fontSize: "16px",
                                                    backgroundColor: "#f8f9fa",
                                                }}
                                            />
                                            {searchQuery && <X size={18} style={{ cursor: "pointer", marginRight: "8px" }} onClick={clearSearch} />}

                                            <button
                                                type="button"
                                                className="btn d-flex align-items-center justify-content-center rounded-circle ms-2"
                                                onClick={toggleListening}
                                                style={{
                                                    width: "45px",
                                                    height: "45px",
                                                    background: isListening
                                                        ? "linear-gradient(135deg, #ff416c,rgb(188, 43, 255))"
                                                        : "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient color
                                                    transition: "all 0.3s ease-in-out",
                                                    boxShadow: isListening
                                                        ? "0 0 15px rgba(255, 65, 108, 0.7), 0 0 30px rgba(255, 75, 43, 0.6)"
                                                        : "0 0 10px rgba(26, 115, 232, 0.5)", // Glowing effect
                                                    animation: isListening ? "pulse 1.5s infinite" : "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <FaMicrophone
                                                    size={22}
                                                    color="white"
                                                    style={{
                                                        transform: isListening ? "scale(1.2)" : "scale(1)",
                                                        transition: "transform 0.3s ease-in-out",
                                                    }}
                                                />
                                            </button>
                                        </div>
                                        <Label
                                            className="ms-2 mb-0 text-muted"
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: "18px", // Increased font size for better visibility
                                                background: "linear-gradient(45deg, #ff8c00, #ff0080, #8000ff)", // More vibrant AI-themed gradient
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent", // Ensures visibility of gradient text
                                            }}
                                        >
                                            Vadodara
                                        </Label>
                                        {/* <div
                                                  ref={dropdownRef}
                                                  className="ms-2 me-4"
                                                  style={{ position: "relative", minWidth: "100px" }}
                                                  onMouseEnter={() => setIsDropdownOpenarea(true)}
                                                  onMouseLeave={(e) => {
                                                    if (!dropdownRef.current.contains(e.relatedTarget)) {
                            
                                                    }
                                                  }}
                                                >
                                                  <div
                                                    onClick={toggleDropdown}
                                                    style={{
                                                      height: "45px",
                                                      fontSize: "14px",
                                                      padding: "10px",
                                                      borderRadius: "10px",
                                                      cursor: "pointer",
                                                      border: "0.5px solid #ccc",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "space-between",
                                                      flexWrap: "wrap",
                                                      minWidth: "170px",
                                                    }}
                                                  >
                                                    {selectedAreas.length > 0 ? selectedAreas.join(", ") : "Select Area"}
                                                    <span>▼</span>
                                                  </div>
                            
                                                  {isDropdownOpenarea && (
                                                    <div
                                                      className="dropdown-modal"
                                                      style={{
                                                        position: "absolute",
                                                        top: "45px",
                                                        left: "0",
                                                        width: "250px",
                                                        backgroundColor: "#fff",
                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                        borderRadius: "8px",
                                                        zIndex: 1000,
                                                        padding: "15px",
                                                      }}
                                                    >
                                                      <strong>Select Area:</strong>
                                                      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                                        {vadodaraAreas.slice(0, visibleCount).map((area) => (
                                                          <div
                                                            key={area}
                                                            onClick={() => handleSelectArea(area)}
                                                            style={{
                                                              padding: "8px 12px",
                                                              borderRadius: "5px",
                                                              cursor: "pointer",
                                                              backgroundColor: selectedAreas.includes(area) ? "#E0E0E0" : "#F5F5F5",
                                                              border: "1px solid #ccc",
                                                            }}
                                                          >
                                                            {area}
                                                          </div>
                                                        ))}
                                                      </div>
                                                      {visibleCount < vadodaraAreas.length && (
                                                        <button
                                                          type="button"
                                                          onClick={(e) => loadMoreAreas(e)}
                                                          style={{
                                                            marginTop: "10px",
                                                            width: "100%",
                                                            padding: "8px",
                                                            borderRadius: "5px",
                                                            backgroundColor: "#007bff",
                                                            color: "#fff",
                                                            border: "none",
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          Load More
                                                        </button>
                                                      )}
                                                    </div>
                                                  )}
                                                </div> */}
                                        <div
                                            ref={dropdownRef}
                                            className="ms-2 me-4"
                                            style={{ position: "relative", minWidth: "100px" }}
                                            onMouseEnter={() => setIsDropdownOpenarea(true)}
                                            onMouseLeave={(e) => {
                                                if (!dropdownRef.current.contains(e.relatedTarget)) {
                                                    setIsDropdownOpenarea(false);
                                                }
                                            }}
                                        >

                                            <div
                                                onClick={toggleDropdown}
                                                style={{
                                                    height: "45px",
                                                    fontSize: "14px",
                                                    padding: "10px",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    border: "0.5px solid #ccc",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    flexWrap: "wrap",
                                                    minWidth: "170px",
                                                }}
                                            >
                                                {selectedAreas.length > 0 ? selectedAreas.join(", ") : "Select Area"}
                                                <span>▼</span>
                                            </div>

                                            {isDropdownOpenarea && (
                                                <div
                                                    className="dropdown-modal"
                                                    style={{
                                                        position: "absolute",
                                                        top: "45px",
                                                        left: "0",
                                                        width: "250px",
                                                        backgroundColor: "#fff",
                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                        borderRadius: "8px",
                                                        zIndex: 1000,
                                                        padding: "15px",
                                                    }}
                                                >
                                                    <strong>Select Area:</strong>

                                                    {/* Search Input */}
                                                    <input
                                                        type="text"
                                                        placeholder="Search area..."
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            marginTop: "10px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "5px",
                                                            outline: "none",
                                                        }}
                                                    />

                                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                                        {filteredAreas.slice(0, visibleCount).map((area) => (
                                                            <div
                                                                key={area}
                                                                onClick={() => handleSelectArea(area)}
                                                                style={{
                                                                    padding: "8px 12px",
                                                                    borderRadius: "5px",
                                                                    cursor: "pointer",
                                                                    backgroundColor: selectedAreas.includes(area) ? "#E0E0E0" : "#F5F5F5",
                                                                    border: "1px solid #ccc",
                                                                }}
                                                            >
                                                                {area}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {visibleCount < filteredAreas.length && (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => loadMoreAreas(e)}
                                                            style={{
                                                                marginTop: "10px",
                                                                width: "100%",
                                                                padding: "8px",
                                                                borderRadius: "5px",
                                                                backgroundColor: "#007bff",
                                                                color: "#fff",
                                                                border: "none",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            Load More
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div
                                            ref={dropdownRef}
                                            className="me-2"
                                            style={{ position: "relative", minWidth: "200px" }}
                                            onMouseEnter={() => setIsDropdownOpen(true)}
                                            onMouseLeave={(e) => {
                                                if (!dropdownRef.current.contains(e.relatedTarget)) {
                                                    setIsDropdownOpen(false);
                                                }
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "45px",
                                                    fontSize: "14px",
                                                    padding: "10px",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    border: "1px solid #ccc",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                {propertyType || "Select Property Type"}
                                                <span>▼</span>
                                            </div>
                                            {isDropdownOpen && (
                                                <div
                                                    className="dropdown-modal"
                                                    style={{
                                                        position: "absolute",
                                                        top: "45px",
                                                        left: "0",
                                                        width: "400px",
                                                        backgroundColor: "#fff",
                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                        borderRadius: "8px",
                                                        zIndex: 1000,
                                                        padding: "15px",
                                                    }}
                                                    onMouseEnter={() => setIsDropdownOpen(true)}
                                                    onMouseLeave={(e) => {
                                                        if (!dropdownRef.current.contains(e.relatedTarget)) {
                                                            setIsDropdownOpen(false);
                                                        }
                                                    }}
                                                >
                                                    <div>
                                                        {propertyOptions.map((option, index) => (
                                                            <div
                                                                key={index}
                                                                onClick={() => handleSelectProperty(option)}
                                                                style={{
                                                                    padding: "10px",
                                                                    cursor: "pointer",
                                                                    borderBottom: "1px solid #eee",
                                                                    fontWeight: propertyType === option ? "bold" : "normal",
                                                                    color: propertyType === option ? "#5A189A" : "#000",
                                                                }}
                                                            >
                                                                {option}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {/* Sub-options based on Property Type */}
                                                    {propertyType === "Residential" && (
                                                        <div style={{ marginTop: "10px" }}>
                                                            <strong>Residential Type:</strong>
                                                            <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                                                                {residentialOptions.map((option) => (
                                                                    <div
                                                                        key={option}
                                                                        onClick={() => handleSubPropertySelect(option)}
                                                                        style={{
                                                                            padding: "8px 12px",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer",
                                                                            backgroundColor: subPropertyType === option ? "#E0E0E0" : "#F5F5F5",
                                                                            border: "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {option}
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Show BHK options if a sub-option is selected */}
                                                            {subPropertyType && (
                                                                <div style={{ marginTop: "10px" }}>
                                                                    <strong>BHK Options:</strong>
                                                                    <div style={{ display: "flex", gap: "10px", marginTop: "5px", flexWrap: "wrap" }}>
                                                                        {bhkOptions.map((option) => (
                                                                            <div
                                                                                key={option}
                                                                                onClick={() => handleBHKSelect(option)}
                                                                                style={{
                                                                                    padding: "8px 12px",
                                                                                    borderRadius: "5px",
                                                                                    cursor: "pointer",
                                                                                    backgroundColor: selectedBHK === option ? "#E0E0E0" : "#F5F5F5",
                                                                                    border: "1px solid #ccc",
                                                                                }}
                                                                            >
                                                                                {option}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {propertyType === "Commercial" && (
                                                        <div style={{ marginTop: "10px" }}>
                                                            <strong>Commercial Types (Multi-Select):</strong>
                                                            <div style={{ display: "flex", gap: "10px", marginTop: "5px", flexWrap: "wrap" }}>
                                                                {commercialOptions.map((option) => (
                                                                    <div
                                                                        key={option}
                                                                        onClick={() => handleCommercialSelect(option)}
                                                                        style={{
                                                                            padding: "8px 12px",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer",
                                                                            backgroundColor: selectedCommercialTypes.includes(option) ? "#E0E0E0" : "#F5F5F5",
                                                                            border: "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {option}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {propertyType === "Other Property Types" && (
                                                        <div style={{ marginTop: "10px" }}>
                                                            <strong>Other Property Types:</strong>
                                                            <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                                                                {otherOptions.map((option) => (
                                                                    <div
                                                                        key={option}
                                                                        onClick={() => handleSubPropertySelect(option)}
                                                                        style={{
                                                                            padding: "8px 12px",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer",
                                                                            backgroundColor: subPropertyType === option ? "#E0E0E0" : "#F5F5F5",
                                                                            border: "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {option}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex me-2" style={{ minWidth: "250px" }}>
                                            <Input
                                                type="select"
                                                className="form-select border-0 rounded-pill me-2"
                                                value={minPrice}
                                                onChange={(e) => setMinPrice(e.target.value)}
                                                style={{ height: "45px", backgroundColor: "#f8f9fa", fontSize: "14px" }}
                                            >
                                                <option value="">Min Price</option>
                                                {priceOptions.map((price, index) => (
                                                    <option key={index} value={price}>
                                                        {price}
                                                    </option>
                                                ))}
                                            </Input>

                                            <Input
                                                type="select"
                                                className="form-select border-0 rounded-pill"
                                                value={maxPrice}
                                                onChange={(e) => setMaxPrice(e.target.value)}
                                                style={{ height: "45px", backgroundColor: "#f8f9fa", fontSize: "14px" }}
                                            >
                                                <option value="">Max Price</option>
                                                {priceOptions.map((price, index) => (
                                                    <option key={index} value={price}>
                                                        {price}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>
                                    </Form>
                                    <style>
                                        {`
                                  @keyframes pulse {
                                    0% { box-shadow: 0 0 15px rgba(255, 65, 108, 0.7), 0 0 30px rgba(255, 75, 43, 0.6); }
                                    10% { box-shadow: 0 0 25px rgba(151, 65, 255, 0.9), 0 0 40px rgba(255, 75, 43, 0.8); }
                                    50% { box-shadow: 0 0 15px rgba(255, 65, 108, 0.7), 0 0 30px rgba(255, 75, 43, 0.6); }
                                  }
                                `}
                                    </style>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xl={12} sm={8} >
                                    {Array.isArray(properties) && properties.length > 0 ? (
                                        properties.map((property, index) => (
                                            <Card key={property.id || index} style={cardStyle}
                                                onClick={() =>
                                                    navigate(
                                                        `/residential/${property.title.replace(/\s+/g, "-")}`
                                                    )
                                                }
                                            >

                                                <CardBody>
                                                    <div className="row g-4 align-items-center">
                                                        <div className="col-md-4">

                                                            <div className="product-img position-relative">
                                                                {property.images?.length > 0 && (
                                                                    <img
                                                                        src={`https://aiinrealestate.in/api${property.images[0]}`}
                                                                        alt={property.title}
                                                                        style={{
                                                                            width: "100%", // Ensure it scales properly
                                                                            height: "260px",
                                                                            objectFit: "cover",
                                                                            borderRadius: "16px",
                                                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                                                                            border: "2px solid #FFD700",
                                                                        }}
                                                                    />
                                                                )}

                                                                <div
                                                                    className="position-absolute w-100 text-center"
                                                                    style={{
                                                                        bottom: "-20px",
                                                                        left: "0",
                                                                        color: "#E8E8FF",
                                                                        fontSize: "1rem",
                                                                        fontWeight: "500",
                                                                        padding: "10px 0",
                                                                        background: "rgba(28, 20, 44, 0.9)", // Dark overlay with transparency
                                                                        borderRadius: "0 0 16px 16px",
                                                                    }}
                                                                >
                                                                    {property.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <h5 className="mb-3 text-truncate">
                                                                <Link
                                                                    to={"/residential/4bhk-villa-Krishna-Bhuvi-bhayli-Vadodara"}
                                                                    className="fw-bold"
                                                                    style={{
                                                                        color: "#E8E8FF",
                                                                        fontSize: "1.5rem",
                                                                    }}
                                                                >
                                                                    {property.title}
                                                                </Link>
                                                            </h5>

                                                            {/* Location */}
                                                            <p className="mb-2" style={{ color: "#A3C4FF" }}>
                                                                <i className="bi bi-geo-alt-fill" style={{ color: "#00C6D7" }}></i>                                   {property.location}, {property.city}

                                                            </p>

                                                            {/* Ready to Move Status */}
                                                            <h6
                                                                className="fw-bold mb-3"
                                                                style={{
                                                                    color: "#FFD700", // Gold for highlighting
                                                                }}
                                                            >
                                                                {property.status}
                                                            </h6>

                                                            {/* Carpet Area Details */}
                                                            <div className="d-flex gap-3 mb-3">
                                                                {property?.property_details?.map((detail, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className="p-3 rounded shadow"
                                                                        style={{
                                                                            background: index % 2 === 0
                                                                                ? "linear-gradient(135deg, #6A0572, #9C1DE7)"
                                                                                : "linear-gradient(135deg, #085078, #67B26F)",
                                                                            color: "#FFFFFF",
                                                                            flex: 1,
                                                                        }}
                                                                    >
                                                                        <h6 className="fw-bold">{detail.bedrooms} BHK</h6>
                                                                        <p className="mb-1">Carpet Area: {detail.carpetArea} sq.ft.</p>
                                                                        <p className="mb-0">Price: ₹{detail.price}</p>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Additional Info */}
                                                            <p
                                                                className="mb-3"
                                                                style={{
                                                                    color: "#A3C4FF",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    maxWidth: "100%", // Ensures it stays within its container
                                                                }}
                                                            >
                                                                {property.description}
                                                            </p>

                                                            {/* Ratings */}
                                                            <div className="d-flex align-items-center mb-2">
                                                                <StarRatings
                                                                    // rating={product.rating}
                                                                    starRatedColor="#FFD700"
                                                                    starEmptyColor="#53576D"
                                                                    numberOfStars={0}
                                                                    name="rating"
                                                                    starDimension="20px"
                                                                    starSpacing="2px"
                                                                />
                                                                <span className="ms-2" style={{ color: "#A3C4FF" }}>
                                                                    {/* ({product.ratingCount} reviews) */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>

                                            </Card>
                                        ))
                                    ) : (
                                        <p>Loading properties...</p> // ✅ Prevents crashing while data loads
                                    )}
                                    <div
                                        style={{
                                            position: "fixed",
                                            bottom: "20px",
                                            right: "20px",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            zIndex: 1000,
                                        }}
                                    >
                                        {/* Icons Container */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: "12px",
                                                gap: "10px", // Reduced gap for a more compact design
                                            }}
                                        >
                                            {/* WhatsApp Icon */}
                                            <a
                                                href={generateWhatsAppLink()}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "white",
                                                    fontSize: "1.2rem", // Reduced font size
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "40px", // Reduced icon size
                                                    height: "40px",
                                                    background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                                                    borderRadius: "50%",
                                                    boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                title="Chat on WhatsApp"
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = "scale(1.1)";
                                                    e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "scale(1)";
                                                    e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                                                }}
                                            >
                                                <FaWhatsapp />
                                            </a>

                                            {/* Call Icon */}
                                            <a
                                                href="tel:+919586363303"
                                                style={{
                                                    color: "white",
                                                    fontSize: "1.2rem", // Reduced font size
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "40px", // Reduced icon size
                                                    height: "40px",
                                                    background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                                                    borderRadius: "50%",
                                                    boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                title="Call Us"
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = "scale(1.1)";
                                                    e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "scale(1)";
                                                    e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                                                }}
                                            >
                                                <i className="fas fa-phone" />
                                            </a>
                                        </div>

                                        {/* Query Button */}
                                        <Link
                                            to="/dashboard"
                                            title="Any Questions or Queries?"
                                            style={{
                                                background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                                                border: "none",
                                                borderRadius: "9999px",
                                                padding: "10px 20px", // Adjusted padding
                                                fontSize: "14px", // Reduced font size
                                                color: "white",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                                                transition: "all 0.3s ease",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = "scale(1.1)";
                                                e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = "scale(1)";
                                                e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
                                            }}
                                        >
                                            Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                                        </Link>
                                    </div>

                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(EcommerceProducts);
